import React from 'react';
import styled from 'styled-components';

const Web3SectionWrapper = styled.section`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center; /* 垂直置中 */
  justify-content: center;
  flex-wrap: nowrap;
  background: linear-gradient(180deg, #B6B05F 0%, #000000 100%);
  border-radius: 30px 30px 0px 0px;
  padding: 5% 12%;

  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

const Web3Subtitle = styled.h3`
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.2em;
  color: #FFFF56;
  margin-bottom: 8px;
  text-align: center;

  @media (max-width: 500px) {
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 30px;
  }
`;

const Web3Title = styled.h2`
  font-style: normal;
  font-weight: 700;
  font-size: 52px;
  line-height: 75px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  margin-top: 0px;
  margin-bottom: 0px;
  text-align: center;

  @media (max-width: 500px) {
    font-size: 32px;
    line-height: 10px;
    margin-bottom: 15px;
  }
`;

const Web3TextWrapper = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  color: #FFFFFF;
  text-align: center;
  
  margin-left: 0;

  @media (max-width: 500px) {
    max-width: 100%;
    padding: 0% 0%;
    font-size: 14px;
    line-height: 24px;
  }
`;

const Web3ReadMoreButton = styled.button`
  background-color: transparent;
  color: #FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;
  cursor: pointer;
  margin-top: 25px;

  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    padding: 6px 20px;
    margin-top: 15px;
  }

  &:hover {
    background-color: #FFFFFF;
    color: #1f1f1f;
  }
`;



const Web3TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: center;
  padding: 2% 2% 2% 2%;

  @media (max-width: 500px) {
    padding: 0px;
    max-width: 100%;
  }
`;

const Web3 = () => (
  <Web3SectionWrapper>

    <Web3TitleContainer>
      <Web3Subtitle>web3.0</Web3Subtitle>
      <Web3Title>web3發展建議</Web3Title>
    </Web3TitleContainer>
    <Web3TextWrapper>
      <p>
        web3 是甚麼？ 為甚麼需要 Web3 ?<br/>web3 包含了那些技術?<br/>web3 突破了傳統領域中那些觀點?<br/><br/>臺灣面臨了哪些問題?<br/>web3 公民基礎建設是甚麼，web3 如何協助臺灣?
      </p>
    </Web3TextWrapper>
    
    <a href="/web3" style={{ textDecoration: 'none' }}><Web3ReadMoreButton>閱讀更多</Web3ReadMoreButton></a>
  </Web3SectionWrapper>
);

export default Web3;
